mutation RequestVideoUpload($fileSize: Float!, $durationSeconds: Float) {
  requestVideoUpload(fileSize: $fileSize, durationSeconds: $durationSeconds) {
    uploadUrl
    videoUid
  }
}
